import React from "react";
import { Link } from "react-router-dom";

const PrivacyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 py-4 shadow-sm">
        <div className="max-w-4xl mx-auto px-8">
          <Link
            to="/login"
            className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-indigo-500 to-purple-600 no-underline"
          >
            就活ダッシュボード
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">
          プライバシーポリシー
        </h1>

        <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 space-y-6 text-gray-700 leading-relaxed">
          <section>
            <p className="text-sm text-gray-500 mb-4">
              最終更新日: {new Date().toLocaleDateString("ja-JP")}
            </p>
            <p>
              就活ダッシュボード（以下「本サービス」といいます）は、利用者の個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第1条（収集する情報）
            </h2>
            <p className="mb-2">
              本サービスは、利用者から以下の情報を取得します。
            </p>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                <strong>Googleアカウント情報</strong>
                <p className="ml-6 mt-1 text-sm">
                  本サービスでは、Google
                  OAuthを利用した認証を行っており、以下の情報を取得します：
                </p>
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1 text-sm">
                  <li>メールアドレス</li>
                  <li>氏名</li>
                  <li>プロフィール画像</li>
                </ul>
              </li>
              <li>
                <strong>利用者が入力する情報</strong>
                <p className="ml-6 mt-1 text-sm">
                  本サービスの利用にあたって、利用者が入力する以下の情報を取得します：
                </p>
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1 text-sm">
                  <li>
                    企業情報（企業名、業界、URL、ログインID、パスワード、メモ等）
                  </li>
                  <li>応募状況情報（応募日、選考ステータス等）</li>
                  <li>スケジュール情報（イベント名、日時、種別、メモ等）</li>
                </ul>
              </li>
              <li>
                <strong>アクセス情報</strong>
                <p className="ml-6 mt-1 text-sm">
                  本サービスの利用状況を把握するため、以下の情報を自動的に収集します：
                </p>
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1 text-sm">
                  <li>IPアドレス</li>
                  <li>ブラウザの種類・バージョン</li>
                  <li>アクセス日時</li>
                  <li>利用環境</li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第2条（利用目的）
            </h2>
            <p className="mb-2">
              本サービスは、取得した個人情報を以下の目的で利用します。
            </p>
            <ol className="list-decimal list-inside space-y-2">
              <li>本サービスの提供・運営のため</li>
              <li>利用者の本人確認のため</li>
              <li>利用者からのお問い合わせに対応するため</li>
              <li>本サービスの改善・新サービスの開発のため</li>
              <li>
                利用規約に違反した利用者や、不正・不当な目的で本サービスを利用しようとする利用者の特定をし、ご利用をお断りするため
              </li>
              <li>上記の利用目的に付随する目的</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第3条（個人情報の保管）
            </h2>
            <p className="mb-2">
              本サービスで取得した個人情報は、以下の方法で安全に保管されます。
            </p>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                <strong>データの保存場所</strong>
                <p className="ml-6 mt-1 text-sm">
                  本サービスは、Cloudflare Workers及びCloudflare D1
                  データベースを利用しており、データはCloudflareのグローバルネットワーク上に保存されます。
                </p>
              </li>
              <li>
                <strong>セキュリティ対策</strong>
                <p className="ml-6 mt-1 text-sm">
                  データの送受信には暗号化通信（HTTPS）を使用し、不正アクセス、改ざん、漏洩等を防止するため、適切なセキュリティ対策を実施しています。
                </p>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第4条（個人情報の第三者提供）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                本サービスは、次に掲げる場合を除いて、あらかじめ利用者の同意を得ることなく、第三者に個人情報を提供することはありません。
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>法令に基づく場合</li>
                  <li>
                    人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
                  </li>
                  <li>
                    国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
                  </li>
                </ul>
              </li>
              <li>
                本サービスは、サービスの提供にあたり、以下の第三者サービスを利用しています。これらのサービスは独自のプライバシーポリシーに従って運営されています。
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>
                    Google OAuth（認証サービス）:{" "}
                    <a
                      href="https://policies.google.com/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:underline"
                    >
                      Googleプライバシーポリシー
                    </a>
                  </li>
                  <li>
                    Cloudflare（インフラストラクチャ）:{" "}
                    <a
                      href="https://www.cloudflare.com/privacypolicy/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:underline"
                    >
                      Cloudflareプライバシーポリシー
                    </a>
                  </li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第5条（個人情報の開示・訂正・削除）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                利用者は、本サービスに登録した個人情報について、本サービス内で閲覧、訂正、削除を行うことができます。
              </li>
              <li>
                アカウントを削除することにより、登録した全てのデータが削除されます。ただし、削除したデータの復旧はできませんのでご注意ください。
              </li>
              <li>
                個人情報の開示、訂正、削除等に関するお問い合わせについては、本サービス内のお問い合わせフォームよりご連絡ください。
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第6条（Cookie及びこれに類する技術の利用）
            </h2>
            <p>
              本サービスは、利用者の利便性向上及びサービスの改善のため、Cookie及びこれに類する技術を使用することがあります。これらの技術により取得した情報は、個人を特定できる情報と組み合わせて使用することがあります。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第7条（プライバシーポリシーの変更）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、利用者に通知することなく、変更することができるものとします。
              </li>
              <li>
                変更後のプライバシーポリシーは、本サービス上に掲載したときから効力を生じるものとします。
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第8条（お問い合わせ窓口）
            </h2>
            <p>
              本ポリシーに関するお問い合わせは、本サービス内のお問い合わせフォームよりご連絡ください。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第9条（データの取り扱いに関する注意事項）
            </h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 my-4">
              <p className="font-semibold text-yellow-800 mb-2">
                重要な注意事項
              </p>
              <ul className="list-disc list-inside space-y-1 text-sm text-yellow-900">
                <li>
                  本サービスは就職活動を支援する目的で提供されていますが、入力されたデータ（企業のログイン情報を含む）の安全性を完全に保証するものではありません。
                </li>
                <li>
                  重要な情報を入力する際は、定期的にバックアップを取ることを推奨します。
                </li>
                <li>
                  企業のマイページのパスワード等、機密性の高い情報の管理には十分ご注意ください。
                </li>
                <li>
                  本サービスの利用により発生したいかなる損害についても、当方は責任を負いかねます。
                </li>
              </ul>
            </div>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">以上</p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/login"
            className="text-indigo-600 hover:text-indigo-700 font-medium"
          >
            ← ログインページに戻る
          </Link>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPage;
